import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dow'
})
export class DowPipe implements PipeTransform {

  transform(value: string): Array<string> {
    const daysOfWeek = [];
    if (value.charAt(0) === '1') {
      daysOfWeek.push(' Mon');
    }
    if (value.charAt(1) === '1') {
      daysOfWeek.push(' Tue');
    }
    if (value.charAt(2) === '1') {
      daysOfWeek.push(' Wed');
    }
    if (value.charAt(3) === '1') {
      daysOfWeek.push(' Thu');
    }
    if (value.charAt(4) === '1') {
      daysOfWeek.push(' Fri');
    }
    if (value.charAt(5) === '1') {
      daysOfWeek.push(' Sat');
    }
    if (value.charAt(6) === '1') {
      daysOfWeek.push(' Sun');
    }
    return daysOfWeek;
  }

}
